import { tg } from "./telegram/sdk";

export interface RecentItem {
  title: string;
  sub: string;
  amount: number;
  sign: 1 | -1;
  icon: string;
}

export interface PaymentItem {
  title: string;
  sub: string;
  amount: number;
}

export interface Achievement {
  title: string;
  sub: string;
  unlocked: boolean;
  icon: string;
}

export interface AppState {
  name: string;
  id: number;
  plan: string;
  balance: number;
  streak: number;
  todayEarn: number;
  refs: number;
  refEarned: number;
  activeDays: number;
  rank: number | string;
  totalEarned: number;
  totalSpent: number;
  recent: RecentItem[];
  payments: PaymentItem[];
  sparkData: number[];
  achievements: Achievement[];
  botUsername: string;
}

export const state: AppState = {
  name: "Foydalanuvchi",
  id: 0,
  plan: "FREE",
  balance: 0,
  streak: 0,
  todayEarn: 0,
  refs: 0,
  refEarned: 0,
  activeDays: 0,
  rank: "—",
  totalEarned: 0,
  totalSpent: 0,
  recent: [],
  payments: [],
  sparkData: [],
  achievements: [],
  botUsername: "Bobirovx_bot",
};

/**
 * PHASE 2 DISCIPLINE: ported verbatim from the pre-overhaul file,
 * including its one pre-existing quirk — `state.botUsername` below
 * unconditionally overwrites the correct default above with the demo
 * placeholder `'yourbot'`. That's a bug in the original, not something
 * introduced here. Left in place on purpose: this phase's job is a
 * zero-behavior-diff refactor, not silent bug fixes. Flagged for Phase 3.
 *
 * Per docs/API_CONTRACT.md: this reads `tg.initDataUnsafe.user` for
 * display only (name/id shown in the demo UI). Nothing here is, or should
 * ever become, trusted server-side without the raw `tg.initData` HMAC
 * round-trip — there is no backend to send it to yet regardless.
 */
export function loadUser(): void {
  const tgUser = tg?.initDataUnsafe.user;

  state.name = tgUser ? [tgUser.first_name, tgUser.last_name].filter(Boolean).join(" ") : "Aziz Karimov";
  state.id = tgUser ? tgUser.id : 728341920;
  state.plan = "FREE";
  state.balance = 2480;
  state.streak = 7;
  state.todayEarn = 120;
  state.refs = 14;
  state.refEarned = 700;
  state.activeDays = 23;
  state.rank = 8;
  state.totalEarned = 5230;
  state.totalSpent = 2750;
  state.botUsername = "yourbot"; // pre-existing quirk, see docstring above
  state.sparkData = [40, 52, 48, 61, 58, 74, 69, 88, 82, 96, 90, 108];
  state.recent = [
    { title: "Kunlik bonus", sub: "Bugun, 09:14", amount: 50, sign: 1, icon: "gift" },
    { title: "Referral bonus", sub: "Bugun, 08:02", amount: 70, sign: 1, icon: "users" },
    { title: "Premium sotib olindi", sub: "Kecha, 21:40", amount: 500, sign: -1, icon: "star" },
    { title: "Do’stlik bonusi", sub: "2 kun oldin", amount: 50, sign: 1, icon: "gift" },
    { title: "Stars sotib olindi", sub: "3 kun oldin", amount: 250, sign: -1, icon: "star" },
  ];
  state.payments = [
    { title: "Premium — 500⭐", sub: "2026-07-10", amount: 500 },
    { title: "Boshlang’ich — 100⭐", sub: "2026-06-28", amount: 100 },
  ];
  state.achievements = [
    { title: "Birinchi qadam", sub: "Ro’yxatdan o’tish", unlocked: true, icon: "flag" },
    { title: "7 kunlik streak", sub: "Ketma-ket faollik", unlocked: true, icon: "fire" },
    { title: "10 ta do’st", sub: "Referral", unlocked: true, icon: "users" },
    { title: "Premium", sub: "Tarif sotib olish", unlocked: false, icon: "star" },
    { title: "30 kunlik streak", sub: "Ketma-ket faollik", unlocked: false, icon: "fire" },
    { title: "50 ta do’st", sub: "Referral", unlocked: false, icon: "users" },
  ];
}
